import React from "react";
import '../index.css'

const Header = () => {
    return (
        <div className="headerLayout" style={{  }}>
            <div style={{display:'flex', flexDirection:'row',  alignItems:'center'}}>
                <img src="/images/Logo.png" style={{ width: 70, height: 70 }} />
                <div>
                    <img src="/images/Briezi.png" style={{ width: 167, height: 50, marginLeft: 10 }} />
                </div>
            </div>
        </div>
    )
}

export default Header;
